import { useCallback } from 'react';
import { useAppInfo } from '../contexts/app-info/AppInfoContext';

export const useAuthenticationHelper = () => {
    const { userId: authenticatedUserId } = useAppInfo();

    const checkIfCreatedByMe = useCallback((userId?: string) => userId === authenticatedUserId, [authenticatedUserId]);
    return { checkIfCreatedByMe };
};
